import axios from "@/configuration/axios";
import waitFor from "@/utils/waitFor";
import { organizationHasFeature } from "@/router/reports/react-redirect";

export default {
  strict: true,
  namespaced: true,
  state: {
    isInitialized: false,
    features: null,
  },
  getters: {
    isInitialized: state => state.isInitialized,
    features: state => state.features,
    // helpers
    // Per-organization lookup. The payload is keyed by organization, so a feature can be
    // on for one of a user's organizations and off for another; the router guard has to
    // ask about the organization the target route names, not whichever one happens to be
    // current. Fails closed on a missing payload or an unknown organization.
    hasOrganizationFeatureFor: state => (organizationId, feature) => organizationHasFeature(state.features, organizationId, feature),
    hasOrganizationFeature: (state, getters, rootState, rootGetters) => feature => {
      const organization = rootGetters["organization/organization"]; // too yuck?
      if (!organization) return false;

      return getters.hasOrganizationFeatureFor(organization.id, feature);
    },
    hasReports: (_, getters) => getters.hasOrganizationFeature("reports"),
    hasInvestigations: (_, getters) => getters.hasOrganizationFeature("investigations"),
    hasSso: (_, getters) => getters.hasOrganizationFeature("sso"),
    // Gates the "new console" navbar toggle. Fails closed: no features payload or no
    // current organization reads as off, so the flagged surface stays hidden.
    hasReactConsole: (_, getters) => getters.hasOrganizationFeature("react-console"),
    // Same flag for a named organization — the auto-redirect guard's view, where "current"
    // is the wrong question (see hasOrganizationFeatureFor).
    hasReactConsoleFor: (_, getters) => organizationId => getters.hasOrganizationFeatureFor(organizationId, "react-console"),
  },
  mutations: {
    setFeatures: (state, payload) => {
      state.features = payload;
      state.isInitialized = true;
    },
  },
  actions: {
    initialize: async context => {
      await waitFor(() => context.rootGetters["user/isInitialized"]);

      var user = context.rootGetters["user/user"];
      if (!user) {
        context.commit("setFeatures", null);
        return;
      }

      await axios
        .get(`/v1/users/${user.id}/features`)
        .then(res => context.commit("setFeatures", res.data))
        .catch(() => context.commit("setFeatures", null));
    },
  },
};
